import React, { useState } from "react";

/**
 * Single FAQ item: question & answer with expandable behavior
 */
const FAQItem = ({ question, answer, isOpen, onClick }) => (
  <div className="faq-item border-b mb-2">
    <button
      className="w-full flex items-center justify-between py-4 text-left focus:outline-none transition-colors"
      aria-expanded={isOpen}
      aria-controls={`faq-answer-${question}`}
      onClick={onClick}
      type="button"
    >
      <span className="font-semibold text-base md:text-lg">{question}</span>
      <span
        className={`text-2xl font-bold transition-transform select-none`}
        style={{
          color: "#f59e42",
          transform: isOpen ? "rotate(180deg)" : "none",
        }}
        aria-hidden="true"
      >
        {isOpen ? "−" : "+"}
      </span>
    </button>
    <div
      id={`faq-answer-${question}`}
      className={`faq-answer overflow-hidden transition-all duration-300 ${
        isOpen ? "max-h-52 opacity-100" : "max-h-0 opacity-0"
      }`}
      style={{
        color: "#535353",
      }}
      aria-hidden={!isOpen}
    >
      {isOpen && <div className="pb-4 text-sm md:text-base">{answer}</div>}
    </div>
  </div>
);

/**
 * FAQ parent (container) - receives FAQdata, sectionTitle, sectionDescription
 * Accordion-style interaction (only one open at a time)
 */
const FAQ = ({
  FAQdata = [],
  sectionTitle = "Frequently Asked Questions",
  sectionDescription = "Find answers to the most common questions below. If you need more help, contact our support.",
}) => {
  const [openIdx, setOpenIdx] = useState(null);

  // Safeguard: If FAQdata is not array or empty, fallback gracefully
  const hasFaqs = Array.isArray(FAQdata) && FAQdata.length > 0;

  return (
    <section className="max-w-screen-xl mx-auto px-8 py-8 bg-white rounded-2xl my-8">
      <div className="mb-8 text-center">
        {sectionTitle && (
          <h2 className="main-heading-font-size mb-2 text-[#fe7c0b]">
            {sectionTitle}
          </h2>
        )}
        {sectionDescription && (
          <p className="text-gray-600">{sectionDescription}</p>
        )}
      </div>
      {hasFaqs ? (
        FAQdata.map((faq, idx) => (
          <FAQItem
            key={faq.question || idx}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIdx === idx}
            onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
          />
        ))
      ) : (
        <p className="text-gray-500">No FAQs available.</p>
      )}
    </section>
  );
};

export default FAQ;
